import { Notification } from 'element-ui'
import _ from 'lodash'

import messages from '@/utils/message'

function createOptions (src = '') {
  if (typeof src === 'string') {
    return { message: src || messages.MSG_902() }
  }

  let ccsErrors = _.get(src, 'error.ccsErrors')
  if (ccsErrors == null) {
    // ccsErrors が設定されていない場合
    return _.chain(src)
      .omit('error')
      .cloneDeep()
      .merge({
        title: src.title || '',
        message: src.message ||
          (process.env.NODE_ENV === 'production' ? null : _.get(src, 'error.message')) ||
          messages.MSG_902()
      })
      .value()
  } else {
    let baseOption = _.omit(src, 'error')
    return _.chain(ccsErrors)
      .reduce((acc, cur) => {
        let opt = _.chain(baseOption)
          .cloneDeep()
          .merge({
            title: cur.title || src.title,
            message: cur.message || src.message || messages.MSG_902()
          })
          .value()
        acc.push(opt)
        return acc
      }, [])
      .value()
  }
}

function error (options) {
  _.chain([])
    .concat(createOptions(options))
    .forEach(val => {
      // TODO setTimeout を使わずに Notification.error を連続でコールすると notification が重なってしまう.
      setTimeout(() => { Notification.error(val) })
    })
    .value()
};

function success (options) {
  setTimeout(() => { Notification.success(options) })
}

function warning (options) {
  setTimeout(() => { Notification.warning(options) })
}

function info (options) {
  setTimeout(() => { Notification.info(options) })
}

export default {
  install: function (Vue, opt = {}) {
    Vue.prototype.$notify = {
      success: success,
      warning: warning,
      info: info,
      error: error,
      close: Notification.close,
      closeAll: Notification.closeAll
    }
  }
}
